export const DEFAULT_GRANULARITY_DATA = {
  isTitleCaptured: false,
  isUrlCaptured: false,
  isTypingCaptured: false,
  isClipboardContentCaptured: false,
  isKeyboardShortcutsCaptured: false,
  isCopyPasteElementsCaptured: false,
  isClickElementsCaptured: false,
}

export const TRAINING_DATA_MAX_ROWS_PER_REQUEST = 4000

